<template>
    <div class="card card-body shadow-lg">
        <!-- <h1>Ss</h1> -->
        <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Facere qui quasi, totam hic commodi, exercitationem tempora quam pariatur adipisci esse sed sequi iure minus doloremque voluptate, delectus consequatur vero. Doloremque? -->
    </div>
</template>

<script>

export default {
    name: "Dashboard",
}
</script>